/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';
// template components
import ExperienceCallout from '@nmx/template/dist/componentLibrary/modules/ExperienceCallout';

export const ExperienceCalloutStyled = styled(ExperienceCallout)`
  ${({ theme }) => {
    const smallToMedium = theme.smallToMedium();
    return css`
      .nmx-experience-callout-image-container {
        ${smallToMedium && 'background-position-y: 24%;'}
      }
    `;
  }}
`;
